export const LANGUAGES = {
  EN: 'en',
  DE: 'de',
  ES: 'es',
  FR: 'fr',
  IT: 'it',
  PL: 'pl',
  RO: 'ro',
  CZ: 'cz',
  NL: 'nl',
  TR: 'tr',
  UK: 'uk',
  SK: 'sk',
  BG: 'bg',
  HU: 'hu',
  ZZ: 'zz',
} as const;

export type Language = (typeof LANGUAGES)[keyof typeof LANGUAGES];

const LANGUAGE_CODES: readonly string[] = Object.values(LANGUAGES);

export function isLanguage(value: string): value is Language {
  return LANGUAGE_CODES.includes(value);
}
